import { ExpandMore, ExpandLess } from '@material-ui/icons';
import styled from 'styled-components';
import { Button } from '../../../../common/components/Button/Button';
import { Link } from '../../../../common/components/Link';
import { ThemeColours } from '../../../../common/styles/ThemeColours';
import {
  FontWeight,
  FONT_STACK,
  FontSize,
  LineHeight,
  Breakpoint,
} from '../../../../common/styles/constants';
import { HIDE_SCROLL_BAR } from '../../../../common/styles/mixins';
import { onMobile } from '../../../../common/styles/onMobile';

export const LinkContainer = styled.div`
  ${HIDE_SCROLL_BAR};

  ${onMobile} {
    overflow-y: auto;
    white-space: nowrap;
  }
`;

export const LinkSectionView = styled.div`
  ${FONT_STACK}
  border-bottom: 1px solid ${ThemeColours.mono300};
  color: ${ThemeColours.mono600};
  font-size: ${FontSize.SMALL};
  line-height: ${LineHeight.REGULAR};
  margin-top: 12px;
  padding-bottom: 15px;
  padding-left: 0px;

  ${Breakpoint.SMALL} {
    border-bottom: none;
    padding-bottom: 10px;
    padding-left: 20px;
  }
`;

export const LinkTitle = styled.div`
  color: ${ThemeColours.black};
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: ${LineHeight.REGULAR};
  margin-bottom: 8px;
`;

export const StyledLink = styled(Link)`
  color: ${ThemeColours.primary500};
  display: block;
  font-size: ${FontSize.EXTRA_SMALL};
  font-weight: ${FontWeight.REGULAR};
  text-decoration: none;

  &:hover {
    color: ${ThemeColours.primary700};
  }
`;

export const SeeMoreToggle = styled(Button)`
  background: none;
  border: none;
  color: ${ThemeColours.primary500};
  font-size: ${FontSize.EXTRA_SMALL};
  font-weight: ${FontWeight.SEMI_BOLD};
  height: 25px;
  margin-left: 10px;
  width: 67px;

  &:active,
  :hover,
  :focus {
    border: none;
    box-shadow: none;
  }
`;

export const StyledExpandMore = styled(ExpandMore)`
  margin-top: 2px;
`;

export const StyledExpandLess = styled(ExpandLess)`
  margin-top: 2px;
`;
